﻿import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface Props {
  show: boolean;
  title?: string;
  message: string;
  variant?: 'danger' | 'warning' | 'primary';
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmModal({ show, title, message, variant = 'danger', onConfirm, onCancel }: Props) {
  const { t } = useTranslation();
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title || t('actions.confirm')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>{t('actions.cancel')}</Button>
        <Button variant={variant} onClick={onConfirm}>{t('actions.confirm')}</Button>
      </Modal.Footer>
    </Modal>
  );
}
